module.exports = __webpack_public_path__ + "img/produto_zooxsmart_pay.9b6315bb.png";